import React from 'react'
import { useTranslation } from 'react-i18next'

export const OutofStock = React.memo(
    () => {
        const { t } = useTranslation();
        return (
            <div className="text-base mb-2 font-semibold  border-round-sm text-center fadein animation-duration-1000 ">
                <span className="text-red-600 fadeout animation-duration-3000  animation-iteration-infinite border-red-500 p-1 pl-3 pr-3 bg-red-50  border-round-xl " >{t('Out of Stock')}</span>
            </div>
        )
    }
)

